import { createFileRoute } from "@tanstack/react-router";
import { UpdatePasswordPage } from "~/features/auth/pages/update-password";
import { UpdatePasswordSearchParams } from "~/features/auth/types";

export const Route = createFileRoute("/(auth)/_auth/update-password")({
  component: () => <UpdatePasswordPage />,
  validateSearch: (search: Record<string, unknown>): UpdatePasswordSearchParams => {
    return {
      token: search.token as string | undefined,
    };
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen w-full items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Update password Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
